(() => {
  const colorMap = {black:'#171717',red:'#d61e31',white:'#f2f0ea',cream:'#e5d7bb',grey:'#898989',gray:'#898989',silver:'#bbb',blue:'#205ec4',navy:'#15243c',yellow:'#edc91b',pink:'#ed96bc',green:'#41654f',brown:'#79573f',orange:'#e67c30',purple:'#7651a9',gold:'#bd983b',clear:'linear-gradient(135deg,#eee 50%,#aaa 50%)','černá':'#171717','červená':'#d61e31','bílá':'#f2f0ea','modrá':'#205ec4','žlutá':'#edc91b','růžová':'#ed96bc'};
  Object.assign(colorMap,{zwart:'#171717',rood:'#d61e31',wit:'#f2f0ea',crème:'#e5d7bb',grijs:'#898989',zilver:'#bbb',blauw:'#205ec4',marineblauw:'#15243c',geel:'#edc91b',roze:'#ed96bc',groen:'#41654f',bruin:'#79573f',oranje:'#e67c30',paars:'#7651a9',goud:'#bd983b'});
  const same = (a,b) => String(a) === String(b);
  const initGallery = gallery => {
    const slides = [...gallery.querySelectorAll('.rw-slide')];
    const thumbs = [...gallery.querySelectorAll('[data-thumb-id]')];
    const stage = gallery.querySelector('.rw-gallery-stage');
    let active = 0, startX = 0, startY = 0;
    gallery.classList.add('is-enhanced');
    const controls = gallery.querySelector('[data-gallery-controls]');
    controls.hidden = slides.length <= 1;
    const counter = gallery.querySelector('[data-gallery-counter]');
    counter.hidden = slides.length <= 1;
    const show = (index, notify = false) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide,i) => {
        slide.hidden = i !== active;
        if(i !== active) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('iframe').forEach(frame => {
            if(frame.src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
            if(frame.src.includes('vimeo')) frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), '*');
          });
        }
      });
      thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === active)));
      counter.textContent = `${String(active+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
      if (notify) gallery.dispatchEvent(new CustomEvent('rw:media-change',{bubbles:true,detail:{media:slides[active].dataset.mediaId}}));
    };
    gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(active-1,true));
    gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>show(active+1,true));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',e=>{e.preventDefault();show(i,true)}));
    stage.addEventListener('keydown',e=>{
      if(e.target.closest('video,iframe,model-viewer')) return;
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1),true)}
    });
    stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY},{passive:true});
    stage.addEventListener('touchend',e=>{
      if(e.target.closest('video,iframe,model-viewer'))return;
      const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)show(active+(dx<0?1:-1),true);
    },{passive:true});
    show(0);
    return {showMedia(id){const index=slides.findIndex(s=>same(s.dataset.mediaId,id));if(index>=0)show(index)},show};
  };
  const setup = (root=document) => {
    root.querySelectorAll('[data-product-section]').forEach(section=>{
      if(section.dataset.initialized)return;
      const select=section.querySelector('[data-variant-select]');
      const data=section.querySelector('[data-variant-data]');
      if(!select||!data)return;
      let variants;try{variants=JSON.parse(data.textContent)}catch{return}
      if(!variants.length)return;
      section.dataset.initialized='true';
      const galleryElement=section.querySelector('[data-gallery]');
      const gallery=galleryElement?initGallery(galleryElement):null;
      const groups=[...section.querySelectorAll('[data-option-index]')];
      const colorGroup=groups.find(g=>g.dataset.optionKind==='color');
      const colorIndex=colorGroup?Number(colorGroup.dataset.optionIndex):-1;
      let selectedVariant=variants.find(v=>same(v.id,select.value))||variants[0];
      let choices=[...selectedVariant.options];let pending=false;
      const add=section.querySelector('[data-add-button]');
      const stickyButton=section.querySelector('[data-sticky-button]');
      const form=select.form;
      let refreshSticky=()=>{};
      section.querySelector('[data-options]').hidden=false;
      section.querySelector('.native-variant').hidden=true;
      section.querySelectorAll('[data-swatch]').forEach(swatch=>{
        if(!swatch.style.getPropertyValue('--swatch'))swatch.style.setProperty('--swatch',colorMap[swatch.dataset.swatch.trim().toLowerCase()]||'linear-gradient(135deg,#ccc 0 48%,#333 49% 100%)');
      });
      const update=(source='initial',changedIndex=-1)=>{
        selectedVariant=variants.find(v=>v.options.every((val,i)=>same(val,choices[i])));
        groups.forEach(group=>{
          const index=Number(group.dataset.optionIndex);
          group.querySelector('[data-selected-value]').textContent=choices[index]||'';
          group.querySelectorAll('[data-option-value]').forEach(button=>{
            const value=button.dataset.optionValue;
            const candidates=variants.filter(v=>same(v.options[index],value)&&v.options.every((val,j)=> j===index || index===colorIndex || same(val,choices[j])));
            const available=candidates.some(v=>v.available);
            button.setAttribute('aria-pressed',String(same(value,choices[index])));
            button.classList.toggle('is-unavailable',!available);
            button.title=!candidates.length?window.RacewearI18n("not_offered"):!available?window.RacewearI18n("sold_combination"):value;
            button.setAttribute('aria-label',value+(!candidates.length?window.RacewearI18n("not_offered_suffix"):!available?window.RacewearI18n("sold_suffix"):''));
          });
        });
        groups.filter(g=>g.dataset.optionKind==='padding').forEach(group=>{
          const index=Number(group.dataset.optionIndex);
          const matches=value=>variants.find(v=>same(v.options[index],value)&&v.options.every((val,j)=>j===index||same(val,choices[j])));
          const standard=matches(group.dataset.paddingStandard),extra=matches(group.dataset.paddingExtra);
          const toggle=group.querySelector('.rw-padding-toggle');
          toggle.disabled=!same(choices[index],group.dataset.paddingExtra)&&!extra?.available;
          const amount=extra&&standard?extra.priceAmount-standard.priceAmount:0;
          const currency=window.Shopify?.currency?.active;
          group.querySelector('[data-padding-surcharge]').textContent=amount>0&&currency?'+'+new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(amount/100):'';
        });
        const available=!!selectedVariant?.available;
        select.value=selectedVariant?String(selectedVariant.id):'';
        section.querySelector('[data-price]').textContent=selectedVariant?.price||window.RacewearI18n("unavailable");
        const compare=section.querySelector('[data-compare]');compare.textContent=selectedVariant?.compare||'';compare.hidden=!selectedVariant?.compare;
        section.querySelector('[data-availability]').textContent=selectedVariant?(available?window.RacewearI18n("available_selection"):window.RacewearI18n("sold_selection")):window.RacewearI18n("combination_note");
        section.querySelector('[data-availability]').classList.toggle('is-unavailable',!available);
        const stock=section.querySelector('[data-stock]');
        if(stock){const n=selectedVariant?.stock;stock.hidden=!(available&&Number.isInteger(n)&&n>0&&n<=10);stock.textContent=stock.hidden?'':window.RacewearI18n("stock", {quantity:n});}
        const label=pending?window.RacewearI18n("adding"):selectedVariant?(available?window.RacewearI18n("add_bag"):window.RacewearI18n("sold_caps")):window.RacewearI18n("unavailable_caps");
        [add,stickyButton].filter(Boolean).forEach(b=>{b.disabled=!available||pending;b.textContent=label;b.setAttribute('aria-busy',String(pending))});
        const quantity=form.querySelector('[name=quantity]');if(quantity)quantity.value=selectedVariant?.min||1;
        const dynamic=form.querySelector('[data-dynamic-checkout]');if(dynamic)dynamic.hidden=!available;
        const stickyPrice=section.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=selectedVariant?.price||window.RacewearI18n("unavailable");
        const stickySelection=section.querySelector('[data-sticky-selection]');if(stickySelection)stickySelection.textContent=choices.join(' / ');
        if(source==='option'||source==='initial'){
          const representative=selectedVariant||variants.find(v=>colorIndex>=0&&same(v.options[colorIndex],choices[colorIndex]));
          if(source==='initial'||changedIndex===colorIndex||colorIndex<0)gallery?.showMedia(representative?.media);
        }
        if(source==='option'||source==='gallery'){
          const url=new URL(location.href);url.searchParams.delete('option_values');
          if(selectedVariant)url.searchParams.set('variant',selectedVariant.id);else url.searchParams.delete('variant');
          history.replaceState({},'',url);
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }
        refreshSticky();
      };
      groups.forEach(group=>group.addEventListener('click',e=>{
        const button=e.target.closest('[data-option-value]');if(!button)return;
        const index=Number(group.dataset.optionIndex);choices[index]=group.dataset.optionKind==='padding'&&same(choices[index],group.dataset.paddingExtra)?group.dataset.paddingStandard:button.dataset.optionValue;update('option',index);
      }));
      galleryElement?.addEventListener('rw:media-change',e=>{
        if(colorIndex<0)return;
        // Read the nearest preceding featured product photo so its following model photo shares its colour.
        const slideIds=[...galleryElement.querySelectorAll('[data-media-id]')].map(s=>s.dataset.mediaId);
        let pos=slideIds.indexOf(e.detail.media),candidate;
        while(pos>=0&&!candidate){candidate=variants.find(v=>v.media&&same(v.media,slideIds[pos]));pos--}
        if(candidate){choices[colorIndex]=candidate.options[colorIndex];update('gallery')}
      });
      section.querySelector('[data-fit-link]')?.addEventListener('click',()=>{const guide=section.querySelector('.size-inline');if(guide)guide.open=true});
      const sticky=section.querySelector('[data-sticky-buy]');
      if(sticky){
        let frame=0;
        const positionSticky=()=>{
          frame=0;
          const rect=add.getBoundingClientRect();
          const beforeOptions=rect.top>=window.innerHeight;
          sticky.hidden=rect.bottom>0&&rect.top<window.innerHeight;
          stickyButton.type=beforeOptions?'button':'submit';
          stickyButton.dataset.chooseOptions=String(beforeOptions);
          stickyButton.disabled=pending||(!beforeOptions&&!selectedVariant?.available);
          stickyButton.textContent=pending?window.RacewearI18n('adding'):beforeOptions?window.RacewearI18n('choose_size'):selectedVariant?(selectedVariant.available?window.RacewearI18n('add_bag'):window.RacewearI18n('sold_caps')):window.RacewearI18n('unavailable_caps');
        };
        refreshSticky=positionSticky;
        const onScroll=()=>{if(!frame)frame=requestAnimationFrame(positionSticky)};
        const onStickyClick=()=>{
          if(stickyButton.dataset.chooseOptions!=='true')return;
          const target=section.querySelector('[data-option-kind="size"]')||section.querySelector('[data-options]');
          target?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
          target?.querySelector('button')?.focus({preventScroll:true});
        };
        stickyButton.addEventListener('click',onStickyClick);
        window.addEventListener('scroll',onScroll,{passive:true});
        window.addEventListener('resize',onScroll);
        const resizeObserver=window.ResizeObserver?new ResizeObserver(onScroll):null;
        resizeObserver?.observe(section.querySelector('.product-layout'));
        positionSticky();
        section.rwCleanup=()=>{window.removeEventListener('scroll',onScroll);window.removeEventListener('resize',onScroll);stickyButton.removeEventListener('click',onStickyClick);resizeObserver?.disconnect();cancelAnimationFrame(frame)};
      }
      section.querySelector('[data-share]')?.addEventListener('click',async()=>{
        const status=section.querySelector('[data-share-status]');
        try{if(navigator.share){await navigator.share({title:document.title,url:location.href})}else{await navigator.clipboard.writeText(location.href);status.textContent=window.RacewearI18n("copied")}}catch(e){if(e.name!=='AbortError')status.textContent=window.RacewearI18n("share_help")}
      });
      form.addEventListener('submit',async e=>{
        if(form.hasAttribute('data-preview-form'))return;
        if(e.submitter?.name!=='add'&&e.submitter!==stickyButton)return;
        e.preventDefault();if(!selectedVariant?.available||pending)return;
        const payload=new FormData(form);pending=true;update('busy');
        const message=section.querySelector('[data-form-message]');message.hidden=true;
        try{
          const base=window.Shopify?.routes?.root||'/';
          const response=await fetch(base+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:payload});
          const item=await response.json();
          if(!response.ok)throw new Error(typeof item.description==='string'?item.description:window.RacewearI18n("add_error"));
          window.location.assign(document.querySelector('.bag-link')?.href || base+'cart');
        }catch(error){message.textContent=error.message||window.RacewearI18n("retry_error");message.hidden=false}
        finally{pending=false;update('busy')}
      });
      update();
    });
    root.querySelectorAll('.rw-hero-pause').forEach(button=>{
      if(button.dataset.initialized)return;button.dataset.initialized='true';
      button.addEventListener('click',()=>{const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?window.RacewearI18n("play_slideshow"):window.RacewearI18n("pause_slideshow"));button.textContent=paused?'▶':'Ⅱ';button.closest('.hero-visual').classList.toggle('rw-hero-paused',paused)});
    });
    root.querySelectorAll('#RacewearCart').forEach(form=>{
      if(form.dataset.initialized)return;form.dataset.initialized='true';
      form.addEventListener('change',e=>{if(e.target.matches('[name="updates[]"]')&&form.reportValidity())form.requestSubmit(form.querySelector('[data-cart-update]'));});
    });
    root.querySelectorAll('.rw-tape-toggle').forEach(button=>{
      if(button.dataset.initialized)return;button.dataset.initialized='true';
      button.addEventListener('click',()=>{const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?window.RacewearI18n("play_announcement"):window.RacewearI18n("pause_announcement"));button.textContent=paused?'▶':'Ⅱ';button.closest('.rw-announcement').classList.toggle('is-paused',paused)});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-product-section]').forEach(s=>s.rwCleanup?.()));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mobile-nav[open]').forEach(m=>{m.open=false;m.querySelector('summary').focus()})});
  document.addEventListener('click',e=>{if(e.target.closest('.mobile-nav nav a'))e.target.closest('.mobile-nav').open=false});
})();

// Product lookbook: responsive, keyboard accessible and paused when out of view.
(()=>{
  function setupLookbooks(root=document){
    root.querySelectorAll('[data-lookbook]').forEach(lookbook=>{
      if(lookbook.dataset.ready)return;
      lookbook.dataset.ready='true';
      const track=lookbook.querySelector('[data-lookbook-track]');
      const cards=[...track.querySelectorAll('[data-lookbook-card]')];
      const pages=[...lookbook.querySelectorAll('[data-lookbook-page]')];
      const count=lookbook.querySelector('[data-lookbook-current]');
      const play=lookbook.querySelector('[data-lookbook-play]');
      const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
      let current=0,visible=false,hover=false,focused=false,manualPause=false,timer=null;
      const canPlay=()=>visible&&!hover&&!focused&&!manualPause&&!reduce.matches&&!document.hidden&&!dialog.open&&lookbook.isConnected;
      function refresh(){
        clearInterval(timer);
        lookbook.toggleAttribute('data-lookbook-paused',!canPlay());
        if(canPlay())timer=setInterval(()=>go((current+1)%cards.length),4800);
      }
      function setCurrent(index){
        if(index===current)return;
        current=index;
        count.textContent=String(index+1).padStart(2,'0');
        pages.forEach((page,i)=>{if(i===index)page.setAttribute('aria-current','true');else page.removeAttribute('aria-current')});
      }
      function go(index){
        setCurrent(index);
        track.scrollTo({left:cards[index].offsetLeft-cards[0].offsetLeft,behavior:reduce.matches?'instant':'smooth'});
        refresh();
      }
      lookbook.querySelector('[data-lookbook-back]').addEventListener('click',()=>go((current-1+cards.length)%cards.length));
      lookbook.querySelector('[data-lookbook-next]').addEventListener('click',()=>go((current+1)%cards.length));
      pages.forEach((page,i)=>page.addEventListener('click',()=>go(i)));
      track.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();go((current+(event.key==='ArrowRight'?1:-1)+cards.length)%cards.length);
        }
      });
      let scrollFrame=0;
      track.addEventListener('scroll',()=>{
        cancelAnimationFrame(scrollFrame);
        scrollFrame=requestAnimationFrame(()=>{
          const left=track.scrollLeft;
          let closest=0,best=Infinity;
          cards.forEach((card,i)=>{const distance=Math.abs(card.offsetLeft-cards[0].offsetLeft-left);if(distance<best){best=distance;closest=i}});
          if(closest!==current){setCurrent(closest);refresh()}
        });
      },{passive:true});
      play.addEventListener('click',()=>{
        manualPause=!manualPause;
        play.setAttribute('aria-pressed',String(manualPause));
        play.setAttribute('aria-label',manualPause?window.RacewearI18n("play_auto"):window.RacewearI18n("pause_auto"));
        play.innerHTML=manualPause?'▶ <span>'+window.RacewearI18n('play')+'</span>':'Ⅱ <span>'+window.RacewearI18n('pause')+'</span>';
        refresh();
      });
      lookbook.addEventListener('pointerenter',()=>{hover=true;refresh()});
      lookbook.addEventListener('pointerleave',()=>{hover=false;refresh()});
      lookbook.addEventListener('focusin',()=>{focused=true;refresh()});
      lookbook.addEventListener('focusout',()=>{setTimeout(()=>{focused=lookbook.contains(document.activeElement);refresh()},0)});
      document.addEventListener('visibilitychange',refresh);
      reduce.addEventListener?.('change',refresh);
      if('IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;refresh()},{threshold:.35});
        observer.observe(lookbook);
      }else{visible=true;refresh()}
      const dialog=document.createElement('dialog');
      dialog.className='rw-lookbook-dialog';
      dialog.innerHTML='<button type="button" aria-label=window.RacewearI18n("close_photo")>×</button><div></div><p></p>';
      document.body.appendChild(dialog);
      dialog.querySelector('button').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
      dialog.addEventListener('close',refresh);
      cards.forEach((card,i)=>{
        card.tabIndex=0;
        card.setAttribute('role','button');
        card.setAttribute('aria-label',window.RacewearI18n("open_look", {index:i+1}));
        const open=()=>{
          const visual=card.querySelector('img,.rw-lookbook-crop').cloneNode(true);
          dialog.querySelector('div').replaceChildren(visual);
          dialog.querySelector('p').textContent=`LOOK ${String(i+1).padStart(2,'0')} / 05`;
          dialog.showModal();refresh();
        };
        card.addEventListener('click',open);
        card.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open()}});
      });
      refresh();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setupLookbooks());else setupLookbooks();
  document.addEventListener('shopify:section:load',event=>setupLookbooks(event.target));
})();


(() => {
  const setup = (root = document) => root.querySelectorAll('[data-padding-open]').forEach(button => {
    if (button.dataset.paddingBound) return;
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!dialog) return;
    button.dataset.paddingBound = 'true';
    const close = () => dialog.close();
    button.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-padding-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => button.focus({preventScroll:true}));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
